import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { isTeamApiAvatarUrl } from '../utils/avatar-url';

@Directive({
  selector: 'img[appAvatarImage]',
})
export class AvatarImageDirective {
  @Input()
  set appAvatarImage(value: string | null | undefined) {
    if (isTeamApiAvatarUrl(value)) {
      this.renderer.setAttribute(
        this.element.nativeElement,
        'crossorigin',
        'anonymous'
      );
    } else {
      this.renderer.removeAttribute(this.element.nativeElement, 'crossorigin');
    }
  }

  constructor(
    private readonly element: ElementRef<HTMLImageElement>,
    private readonly renderer: Renderer2
  ) {}
}
